import produce from 'immer'

import { SETTINGS, AUTH } from 'store/actions/types'
import { ModeTypes } from 'common/Enums'
import { CallPreferences } from 'store/models/CallPreferences'

const initialState = {
    mode: ModeTypes.Available,
    callPreferences: CallPreferences,
    speakersDevices: [],
    microphoneDevices: [],
    selectedConfigIds: {
        ringtoneId: 0,
        speakersCallDeviceId: null,
        speakerRingtoneDeviceId: null,
        microphoneDeviceId: null
    },
    volume: 100,
    autoReject: false,
    autoPickup: false,
    codecPreferences: [],
    integrationNumberSearch: true,
    searchOnlyKavkomCRM: false
}

export default function userAgentReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case SETTINGS.SET_USER_MODE:
            return produce(state, (draft) => {
                draft.mode = payload
            })

        case AUTH.SIGNOUT_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.mode = ModeTypes.Available
            })

        case SETTINGS.GET_DEVICES_SUCCESS:
            return produce(state, (draft) => {
                const speakers = [
                    { id: 0, name: 'default_device' },
                    ...Object.keys(payload.data.audiooutput).map((key) => payload.data.audiooutput[key])
                ]
                const microphones = [
                    { id: 0, name: 'default_device' },
                    ...Object.keys(payload.data.audioinput).map((key) => payload.data.audioinput[key])
                ]
                draft.speakersDevices = speakers
                draft.microphoneDevices = microphones

                const newSelectedConfigIds = { ...state.selectedConfigIds }
                if (speakers.length && !newSelectedConfigIds.speakersCallDeviceId) {
                    newSelectedConfigIds.speakersCallDeviceId = speakers[0].id
                }
                if (speakers.length && !newSelectedConfigIds.speakerRingtoneDeviceId) {
                    newSelectedConfigIds.speakerRingtoneDeviceId = speakers[0].id
                }
                if (microphones.length && !newSelectedConfigIds.microphoneDeviceId) {
                    newSelectedConfigIds.microphoneDeviceId = microphones[0].id
                }
                draft.selectedConfigIds = newSelectedConfigIds
            })

        case SETTINGS.CHANGE_VOLUME:
            return produce(state, (draft) => {
                draft.volume = payload.value
            })

        case SETTINGS.CHANGE_DEVICE_CONFIG:
            return produce(state, (draft) => {
                const newSelectedConfigIds = { ...state.selectedConfigIds }
                newSelectedConfigIds[payload.configName] = payload.id
                draft.selectedConfigIds = newSelectedConfigIds
            })

        case SETTINGS.CHANGE_CALL_PREFERENCES:
            return produce(state, (draft) => {
                draft.callPreferences = state.callPreferences.map((item) => {
                    return {
                        ...item,
                        isChecked: item.id === payload.id ? payload.checked : item.isChecked
                    }
                })
            })

        case SETTINGS.CHANGE_AUTO_REJECT:
            return produce(state, (draft) => {
                draft.autoReject = payload
            })

        case SETTINGS.CHANGE_AUTO_PICKUP:
            return produce(state, (draft) => {
                draft.autoPickup = payload
            })

        case SETTINGS.SET_CODEC_PREFERENCES:
            return produce(state, (draft) => {
                draft.codecPreferences = payload
            })

        case SETTINGS.SET_INTEGRATION_NUMBER_SEARCH:
            return produce(state, (draft) => {
                draft.integrationNumberSearch = payload
            })

        case SETTINGS.SET_SEARCH_KAVKOMCRM_ONLY:
            return produce(state, (draft) => {
                draft.searchOnlyKavkomCRM = payload
            })

        default:
            return state
    }
}
